// extracted by mini-css-extract-plugin
module.exports = {"container":"GuestOfHonorWorks-module--container--12JmN","work":"GuestOfHonorWorks-module--work--1oECQ"};